import React, { useMemo, useSyncExternalStore } from 'react';
import { View, ScrollView, Text } from 'react-native';
import { makeStyles } from './UpgradeModal.styles';
import ProductCard from './ProductCard';
import { useTranslation } from '@oolio-group/localization';
import { useTheme } from '../../../hooks/useTheme';
import { upsellComboStore } from '../../../store/upsellCombo';

const UpgradeModal = () => {
  const { translate } = useTranslation();
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  const { upsellCombos: products } = useSyncExternalStore(
    upsellComboStore.subscribe,
    upsellComboStore.getSnapshot,
  );

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>
          {translate('modal.wouldYouUpgradeItem')}
        </Text>
      </View>
      <View style={styles.content}>
        <ScrollView showsVerticalScrollIndicator={true}>
          <View style={styles.grid}>
            {products.map(product => (
              <ProductCard product={product} key={product.id} />
            ))}
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default UpgradeModal;
